import department from '@/api/department'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  divisions: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DIVISIONS(state, data) {
    state.divisions = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return department.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return department.store(data)
  },

  async find(context, id) {
    return await department.find(id)
  },

  update(context, data) {
    return department.update(data)
  },

  delete(context, data) {
    return department.destroy(data)
  },

  async dataBeforeCreate(context) {
    if (!context.state.divisions.length > 0) {
      let response = await department.division()
      context.commit('SET_DIVISIONS', response)
    }
  }
}
